<template>
  <div class="container-xl g-0 g-lg-2" :class="[containerClass]">
      <div class="row h-100 g-0 g-lg-2">
        <div class="col h-100">
          <div class="header-small d-flex"  :style="{ backgroundImage: `url(${this.headerbg}) !important` }">
          <template v-if="title">
            <h1 class="" :class="[classProp]" v-if="headlineType === 'h1'">
              {{ title }}
            </h1>
            <h2 class="" :class="[classProp]" v-if="headlineType === 'h2'">
              {{ title }}
            </h2>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'section-header-small',
  props:{
    'containerClass': {type: String, default: ''},
    'title': String,
    'classProp': {type: String, default: 'light bottom left' },
    'headlineType': {type: String, default: "h1"},
    'headerbg': {type: String, default: '/images/temp/header-small-bg1.png'},
  },
  data () {
    return {}
  }
}

</script>